import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { MailCheck } from "lucide-react";

export default function ForgotPassword({ initialEmail = "", onBack }) {
  const { resetPassword } = useAuth();
  const [email, setEmail] = useState(initialEmail);
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    const r = await resetPassword(email);
    setLoading(false);
    if (r.ok) setSent(true); else setErr(r.error);
  };

  if (sent) {
    return (
      <div className="space-y-5" data-testid="reset-sent">
        <div className="flex items-start gap-3 p-4 border border-good/30 bg-good/5 rounded-sm">
          <MailCheck className="w-5 h-5 text-good shrink-0 mt-0.5" />
          <p className="text-sm text-ink">If an account exists for <b>{email}</b>, a password reset link is on its way. Check your inbox and spam folder.</p>
        </div>
        <button onClick={onBack} data-testid="reset-back-btn" className="w-full text-sm text-brand hover:underline">Back to sign in</button>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="space-y-5" data-testid="reset-form">
      <p className="text-sm text-ink-muted">Enter your account email and we'll send you a link to set a new password.</p>
      <input
        type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="reset-email-input"
        className="w-full px-3 py-2.5 border border-ink-line bg-white rounded-sm text-sm focus:outline-none focus:ring-2 focus:ring-brand/20 focus:border-brand"
      />
      {err && <div className="text-sm text-warn bg-warn-soft border border-warn/30 px-3 py-2 rounded-sm" data-testid="reset-error">{err}</div>}
      <button type="submit" disabled={loading} data-testid="reset-submit-btn" className="w-full bg-brand hover:bg-brand-hover disabled:opacity-60 text-white font-medium py-2.5 rounded-sm text-sm transition-colors">
        {loading ? "Sending…" : "Send reset link"}
      </button>
      <button type="button" onClick={onBack} data-testid="reset-cancel-btn" className="w-full text-sm text-ink-muted hover:text-ink">Back to sign in</button>
    </form>
  );
}
